import qs from 'qs';
import { isEmpty } from './isEmpty';
import { tryParseJSON } from './tryParseJSON';

/**
 * @memberof module:util
 * @function
 * @name getSailingPOSTparam
 * @description It gets params for Sailing Schedule POST request.
 *
 * @param {boolean} isFormSubmitSuccess - Whether Form page is used.
 * @param {Object} queryParams - query params from redux store
 * @returns {Object}
 *
 * @example
 * console.log(getSailingPOSTparam(false, queryParams));
 * //{from:{id:"441", name:"Chittagong", country:"Bangladesh"}, to:{id:"442", name:"Coffs Harbour", country:"Australia"}, date:"23 Apr, 2021", type:"api-fcl"}
 * console.log(getSailingPOSTparam(true, queryParams));
 * //{from:{id:"441", name:"Chittagong", country:"Bangladesh", city:"Chittagong"}, to:{id:"442", name:"Coffs Harbour", country:"Australia", name:"Coffs Harbour"}, date:"23 Apr, 2021", type:"api-fcl"}
 */
export const getSailingPOSTparam = (isFormSubmitSuccess, queryParams) => {
  //if form is used the get from/to from redux store otherwise from url

  if (isFormSubmitSuccess) {
    return getFromTo(queryParams);
  }
  //don't get query params from redux because as soon as we change from and to ports
  //dropdown on search bar, it will update the pricing cards as well,
  //so get the from/to from URL instaed
  let from, to, date, type;

  let search = window.location.search;
  search = search && search.substring(1);
  queryParams = qs.parse(search);

  from = tryParseJSON(decodeURIComponent(queryParams.from)) || {};
  to = tryParseJSON(decodeURIComponent(queryParams.to)) || {};
  date = decodeURIComponent(queryParams.date) || '';
  type = decodeURIComponent(queryParams.type) || '';

  //if url params from/to objects have city keys instead of name then map it to name
  if (!isEmpty(from)) {
    from = {
      id: from.id,
      name: from.name || from.city,
      country: from.country,
    };
  }

  if (!isEmpty(to)) {
    to = {
      id: to.id,
      name: to.name || to.city,
      country: to.country,
    };
  }

  queryParams = {
    ...queryParams,
    from,
    to,
    date,
    type,
  };

  return getFromTo(queryParams);
};

const getFromTo = (queryParams) => {
  let from = queryParams.from;
  let to = queryParams.to;
  let date = queryParams.date;
  let type = queryParams.type;

  return { from, to, date, type };
};
